import { Component, OnInit } from '@angular/core';

import * as moment from 'moment';
import * as _ from 'lodash';
import { ExportToCsv } from 'export-to-csv';
import { AgGridAngular } from 'ag-grid-angular';
import { CellClickedEvent, ColDef, GridReadyEvent } from 'ag-grid-community';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { ReportsService } from 'src/app/modules/retailer/services/reports.service';

@Component({
  selector: 'app-sales-data',
  templateUrl: './sales-data.component.html',
  styleUrls: ['./sales-data.component.scss']
})
export class SalesDataComponent implements OnInit {

  public loginData: any;

  public salesDataJSON: any = [];
  public salesDataCSV: any = [];
  public totalTransaction: any = 0;
  public totalSales: any = 0;
  public salesDataLoading: boolean = false;

  public reportFilter: any;

  // Each Column Definition results in one Column.
  public columnDefs: ColDef[] = [
    { field: 'transaction_id', headerName: 'Transaction Id' },
    { field: 'transaction_time', headerName: 'Transaction Time' },
    { field: 'terminal_id', headerName: 'Terminal Id' },
    { field: 'operator_id', headerName: 'Operator Id' },
    { field: 'line_item_count', headerName: 'Line Items' },
    { field: 'upc', headerName: 'UPC' },
    { field: 'department_name', headerName: 'Department' },
    { field: 'item_name', headerName: 'Item Name' },
    { field: 'quantity', headerName: 'Quantity' },
    { field: 'item_amount', headerName: 'Item Amount' },
    { field: 'tax_amount', headerName: 'Tax Amount' },
    { field: 'amount_saved', headerName: 'Amount Saved' },
    { field: 'digital_coupon_id', headerName: 'Digital Coupon Id' },
    { field: 'digital_coupon_value', headerName: 'Digital Coupon Value' },
    { field: 'digital_coupon_quantity', headerName: 'Digital Coupon Quantity' },
    { field: 'total_amount', headerName: 'Total Amount' },
    { field: 'total_tax', headerName: 'Total Tax' },
    { field: 'total_amount_saved', headerName: 'Total Amount Saved' },
    { field: 'customer_name', headerName: 'Customer Name' }
  ];

  // DefaultColDef sets props common to all Columns
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true,
  };

  constructor(
    private _utilService: UtilService,
    private _reportsService: ReportsService
  ) { }

  ngOnInit(): void {
    this.getStorageData();
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('R_LOGIN');
  }

  // On filter change
  async onfilterChange(event: any) {
    this.reportFilter = event;

    this.getSalesData();
  }

  // Get sales data
  getSalesData() {
    if (this.reportFilter) {
      let reportStartDate = moment(this.reportFilter.date_range[0]).format('YYYY-MM-DD');
      let reportEndDate = moment(this.reportFilter.date_range[1]).format('YYYY-MM-DD');

      // Block API call if date range is more than 3 days   
      var dayDiff =  moment(reportEndDate).diff(reportStartDate, 'days');
      if (dayDiff > 2) {
        this._utilService.showToast('Please select date range 3 days or less', '', 'warning', {});
      } else {
        this.salesDataJSON = [];
        this.salesDataCSV = [];
        this.salesDataLoading = true;

        this._reportsService.getSalesData(this.loginData.token, this.loginData.user_details.provider_id, this.reportFilter.store, reportStartDate, reportEndDate).subscribe(async getSalesDataResponse => {
          this.salesDataLoading = false;

          if (getSalesDataResponse.status === true) { // Success
            this.salesDataJSON = getSalesDataResponse.data;

            // Convert JSON to CSV
            let tempDataCSV: any = [];
            for (let i=0; i<=this.salesDataJSON.length-1; i++) {
              for (let j=0; j<=this.salesDataJSON[i].products.length-1; j++) {
                  tempDataCSV.push ({
                  transaction_id: +this.salesDataJSON[i].transaction_id,
                  transaction_time: this.salesDataJSON[i].transaction_time,
                  terminal_id: this.salesDataJSON[i].terminal_id,
                  operator_id: this.salesDataJSON[i].operator_id,
                  line_item_count: this.salesDataJSON[i].line_item_count,
                  upc: this.salesDataJSON[i].products[j].upc,
                  department_name: this.salesDataJSON[i].products[j].deptName,
                  item_name: this.salesDataJSON[i].products[j].itemName,
                  quantity: this.salesDataJSON[i].products[j].quantity,
                  item_amount: this.salesDataJSON[i].products[j].itemAmount,
                  tax_amount: this.salesDataJSON[i].products[j].tax,
                  amount_saved: this.salesDataJSON[i].products[j].amountSaved,
                  digital_coupon_id: this.salesDataJSON[i].products[j].digitalCouponId,
                  digital_coupon_value: this.salesDataJSON[i].products[j].digitalCouponValue,
                  digital_coupon_quantity: this.salesDataJSON[i].products[j].digitalCouponQuantity,
                  total_amount: this.salesDataJSON[i].total_amount,
                  total_tax: this.salesDataJSON[i].total_tax,
                  total_amount_saved: this.salesDataJSON[i].total_amount_saved,
                  customer_name: this.salesDataJSON[i].customer_name
                });
              }
            }

            this.salesDataCSV =  _.orderBy(tempDataCSV, ['transaction_time'], ['desc']); // Sort by transaction time
            //this.totalTransaction =  _(this.salesDataJSON).groupBy('transaction_id', 'transaction_time').size(); // Get transaction count
            this.totalTransaction =  this.salesDataJSON.length; // Get transaction count
            this.totalSales =  _.sumBy(this.salesDataJSON, 'total_amount') // Get sales total
          } else {
            this._utilService.showToast(getSalesDataResponse.message, '', 'error', {});
          }
        }, error => { // Error from getSalesData
          this.salesDataLoading = false;
        });
      }
    }
  }

  // Generate CSV File
  generateCSVFile() {
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      useBom: false,
      useKeysAsHeaders: true,
      filename: 'sales-data'
    };
    const csvExporter = new ExportToCsv(options);

    csvExporter.generateCsv(this.salesDataCSV);
  }

}
